import styled from 'styled-components';

export const ImageReelWrapper = styled.div`
	padding-top: 4em;
	position: relative;

	@media screen and (min-width: 768px) {
		height: 500px;
		padding-top: 5em;
	}
`;

export const ImageReel = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 10px;
	@media screen and (min-width: 768px) {
		grid-template-columns: 15% 15% 15% auto 15%; //repeat(5, 1fr);
		gap: 30px;
		position: absolute;
	}
`;

export const ImageReelItem = styled.img`
	width: 100%;
	// height: 100%;
	height: 250px;
	min-height: 200px;
	border-radius: 5px;
	object-fit: cover;

	@media screen and (min-width: 768px) {
		&:first-child,
		&:nth-child(5n) {
			height: 250px;
			margin-top: 20px;
		}

		&:nth-child(2n) {
			height: 288px;
			margin-top: 100px;
		}

		&:nth-child(3n) {
			height: 207px;
			margin-top: 50px;
		}

		&:nth-child(4n) {
			margin-top: -300px;
			height: 704px;
		}
	}

	@media screen and (max-width: 768px) {
		&:first-child {
			grid-column-start: span 2;
		}
		&:nth-child(4) {
			grid-column-start: span 2;
		}
		&:nth-child(5n) {
			display: none;
		}
	}
`;
